// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../index';

import { LoginResponseSuccessFragmentDoc } from './loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../fragments/costumerConsultant.fragment.generated';
import { LoginResponseFailureFragmentDoc } from './loginResponseFailure.generated';
export const LoginResponseFragmentDoc = `
    fragment loginResponse on LoginResponse {
  ... on LoginResponseSuccess {
    ...loginResponseSuccess
  }
  ... on LoginResponseFailure {
    ...loginResponseFailure
  }
}
    `;